export default __webpack_public_path__ + "static/03-03-analysis-speedgrade-ai-5afdf8237395ee17055d5a9757b6a722.mp4";